
export function mailTrashListGet(page) {
	return {
		type: 'MAIL_TRASH_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function mailTrashItemRestore(pic, callback) {
	return {
		type: 'MAIL_TRASH_ITEM_RESTORE',
		payload: {
			pic: pic,
		},
    callback: callback,
	}
}

export function mailTrashItemDel(pic, callback) {
	return {
		type: 'MAIL_TRASH_ITEM_DEL',
		payload: {
			pic: pic,
		},
    callback: callback,
	}
}
